import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone, Search, MessageSquare } from "lucide-react";
import Logo from "./Logo";
import { NAV, ORG } from "../mock";

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isActive = (path) =>
    path === "/" ? location.pathname === "/" : location.pathname.startsWith(path);

  return (
    <header className="sticky top-0 z-50 w-full">
      {/* Top utility bar */}
      <div className="bg-brand-navy text-white text-xs sm:text-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-9">
          <span className="hidden sm:inline text-slate-200">
            Official website of the Republic of Sierra Leone capital markets regulator
          </span>
          <div className="flex items-center gap-4 ml-auto">
            <a href={`tel:${ORG.phone}`} className="gov-topbar-link inline-flex items-center gap-1.5 text-slate-200">
              <Phone size={13} /> {ORG.phone}
            </a>
            <Link to="/contact" className="gov-topbar-link hidden md:inline-flex items-center gap-1.5 text-slate-200">
              <MessageSquare size={13} /> Contact Us
            </Link>
          </div>
        </div>
      </div>

      {/* Main bar */}
      <div className="bg-white border-b border-slate-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center gap-3">
              <Logo size={48} />
              <div className="leading-tight">
                <div className="font-serif font-bold text-brand-navy text-base sm:text-lg">
                  {ORG.shortName} <span className="hidden sm:inline font-semibold text-slate-700">Sierra Leone</span>
                </div>
                <div className="text-[11px] sm:text-xs text-slate-500 max-w-[260px] sm:max-w-none">
                  International Securities &amp; Exchange Commission
                </div>
              </div>
            </Link>

            {/* Desktop nav */}
            <nav className="hidden lg:flex items-center gap-7">
              {NAV.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`nav-underline text-sm font-semibold text-slate-700 hover:text-brand-navy ${
                    isActive(item.path) ? "active text-brand-navy" : ""
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </nav>

            <div className="flex items-center gap-2">
              <Link
                to="/contact"
                className="hidden sm:inline-flex items-center gap-2 border border-brand-navy text-brand-navy text-sm font-semibold px-4 py-2.5 rounded-md hover:bg-brand-navy hover:text-white transition-colors"
              >
                <MessageSquare size={16} /> Contact Us
              </Link>
              <Link
                to="/regulated-entities"
                className="hidden sm:inline-flex items-center gap-2 bg-brand-green text-white text-sm font-semibold px-4 py-2.5 rounded-md hover:bg-[#0f6339] transition-colors"
              >
                <Search size={16} /> Verify a Firm
              </Link>
              <button
                className="lg:hidden p-2 text-brand-navy"
                onClick={() => setOpen(!open)}
                aria-label="Toggle menu"
              >
                {open ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile nav */}
        {open && (
          <div className="lg:hidden border-t border-slate-200 bg-white">
            <nav className="px-4 py-3 flex flex-col">
              {NAV.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setOpen(false)}
                  className={`py-2.5 text-sm font-semibold border-b border-slate-100 ${
                    isActive(item.path) ? "text-brand-green" : "text-slate-700"
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
